import { Component, OnInit, HostListener, Renderer2, ViewChild, ElementRef, AfterViewInit, ViewChildren, QueryList, ChangeDetectorRef, Inject } from '@angular/core';
import { CacheService } from 'src/app/shared/services/Cache/cache.service';
import { ScrollService } from 'src/app/shared/services/Scroll/scroll.service';
import { CartService } from 'src/app/shared/services/Cart/cart.service';
import { DOCUMENT } from '@angular/common';
import { SharedService } from 'src/app/shared/services/shared/shared.service';
import { Categorias, Company, typeInterface } from 'src/app/shared/Interfaces/company';
import { ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import { PixelService } from 'src/app/shared/services/pixel.service';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { LogsService } from 'src/app/shared/services/logs.service';

@Component({
  selector: 'menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
})

export class MenuComponent implements OnInit, AfterViewInit{
  //#region Variaveis de Elementos HTML
    @ViewChildren('sections') sections!: QueryList<ElementRef>;
    @ViewChild('sections', { read: ElementRef }) sectionsRefs: ElementRef[] = [];
  //#endregion

  //#region Variaveis de estilo
    verifiScrolling = false;
    backgroundLoad = false;
    showSideBar = true;
    emptyProduct = false;
    showInput!: boolean;
    openModalTwo = false;
    readOnlyState: boolean = false;
    darkTheme = this.cacheService.getItemLocal('dark-theme')
  //#endregion

  //#region Variaveis locais
    private verificationRequest = false;
    private scrollTopPosition: number = 0;
    private positions!: ElementRef[];
    typeParam!: typeInterface;
    statusCompany = false;
    nameCompany: string = '';
    nameEmpresa!: string;
    imgLogo!: string;
    imgBackground!: string;
    local: boolean = false;
    nameStatusCompany!: string;
    filter: string = '';
    counterCart: number = 0;
    tabela!: Categorias[];
    company!: Company;
    user!: Cliente;
    isMobile: boolean = false;
    isTablet: boolean = false;
    isDesktop: boolean = false;
    imgsLoadead!: boolean[];
    versionApp: string = '';

  //#endregion

  //#region Inicializadores
    constructor(
      private cacheService: CacheService,
      private scrollService: ScrollService,
      private cartService: CartService,
      private connection: ConnectionService,
      private renderer: Renderer2,
      private sharedService: SharedService,
      @Inject(DOCUMENT) private document: Document,
      private pixelService: PixelService,
      private titleService: Title,
      private metaService: Meta,
      private cdr: ChangeDetectorRef,
      )
      {
        this.cartService.counter$.subscribe(newCount => {
          this.counterCart = newCount;
        });

        this.connection.nameCompany$.subscribe((newNameCompany: string) => {
          this.nameCompany = newNameCompany;
        });

        this.connection.readOnlyState$.subscribe((data) =>{
          this.readOnlyState = data;
        })

        this.connection.typeParam$.subscribe((newTypeParam) => {
          this.typeParam = newTypeParam
          
          if(this.typeParam.type == 0 || this.typeParam.type == 3){
            this.local = false;
          }
          else{
            this.local = true
          }
        });

        this.connection.verificationRequest$.subscribe((newValue) =>{
          this.verificationRequest = newValue
        });

        this.scrollService.scrolling$.subscribe((scrolling) =>{
          this.verifiScrolling = scrolling;
        });

        this.connection.user$.subscribe((User) =>{
          this.user = User;
        });

        this.sharedService.filter$.subscribe((newValue) =>{
          this.filter = newValue
          if(this.filter != ''){
            this.showInput = true;
          }
        });

        this.connection.company$.subscribe((newValue) =>{
          if(newValue)
          {
            setTimeout(() => {
              this.company = newValue;
              this.tabela = this.company.categories;
              this.nameEmpresa = this.company.company.companyName.toUpperCase()
              this.imgLogo = this.company.company.logo;
              this.imgBackground = this.company.company.background;

              this.verifiStatusCompany();
              this.updateMetaTags();
              this.cdr.detectChanges();
            })
          }
          
        })
      }

    ngOnInit(){
      this.versionApp = environment.version;

      //Busca as informações da empresa
      this.getStore();

      //Altera o padding de acordo com o tamanho da tela
      this.alterationLayout();

      //Exibe ou esconde a barra lateral
      this.toggleSideBar();

      //Resgata os produtos no carrinho
      this.cartService.getCartItems();

      //Resgata as posições das categorias
      this.resgataPosition();

      if(this.verificationRequest)
      {
        this.backgroundLoad = true;
      }
    }

    ngAfterViewInit(){
      //Envia o evento Pixel
      setTimeout(() => {
        this.sendEvent();
      }, 2000);

    }

    ngOnDestroy(){}

  //#endregion

  //#region Funções de estilo (Style)

    //Exibe ou esconde a barra lateral
    toggleSideBar(){
      if(window.innerWidth < 1169){
        this.showSideBar = false
      }
      else {
        this.showSideBar = true;
      }
    }

    //Deasabilitao scroll da pagina
    disableScroll(){
      this.renderer.setStyle(this.document.body, 'overflow', 'hidden')
    }

    //Abilita o scroll da pagina
    enableScroll(){
      this.renderer.removeStyle(this.document.body, 'overflow');
    }

    //resgata a posição das sections, para que a side-bar possa usar
    resgataPosition(){
      this.positions = [];
      if(this.sections){
        this.sections.forEach((element: ElementRef) =>{
          this.positions.push(element)
        });
        this.scrollService.loadSections(this.positions);
      }
      this.cdr.detectChanges();
    }

    //Altera o layout da aplicação
    alterationLayout(){
      this.scrollTopPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      //Mobile
      if(window.innerWidth <= 846)
      {
        this.isTablet = false;
        this.isDesktop = false;
        this.isMobile = true;
      }
      //Tablet
      else if(window.innerWidth >= 846 && window.innerWidth <= 1168)
      {
        this.isMobile = false;
        this.isDesktop = false;
        this.isTablet = true;  
      }
      //Desktop
      else{
        this.isDesktop = true;
        this.isMobile = false;
        this.isTablet = false;
      }
    }

    //Quando o background é carregado
    loadBackground(){
      if(!this.verificationRequest)
      {
        setTimeout(() => {
          this.backgroundLoad = true;
        }, 500);
      }
      else{
        this.backgroundLoad = true;
      }

    }

    @HostListener('window:resize', [])
    onResize(){
      this.alterationLayout();
      if(window.innerWidth < 1169){
        this.showSideBar = false
      }
      else {
        this.showSideBar = true;
      }

    }

    @HostListener('window:scroll', [])
    onScroll(): boolean  {
      this.alterationLayout();
      
      return false;
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event: PopStateEvent): void {
      event.preventDefault();
      this.enableScroll();
    }

    //Atualiza o titulo da pagina
    updateMetaTags() {
      this.titleService.setTitle(`${this.company.company.companyName} - Pedeaqui`);
      
      this.metaService.addTags([
        { property: 'og:title', content: `${this.company.company.companyName} - Pedeaqui`},
      ]);
    }

  //#endregion

  //#region Funções de Lógica (Logic)

    //Resgata as informações da empresa
    getStore(){
      if(!this.verificationRequest)
      {
        this.connection.getCompany(this.nameCompany, this.typeParam.type).subscribe((data) =>{});
      }
    }

    //Verifica se a loja esta fechada ou aberta
    verifiStatusCompany(){
      if(this.company.company.status == 0)
      {
        this.nameStatusCompany = 'Loja Fechada';
        this.statusCompany = false;
      }
      else if(this.company.company.status == 1)
      {
        this.nameStatusCompany = 'Loja Aberta';
        this.statusCompany = true;
      }
    }

    //Envia o evento de ViewContent para meta
    sendEvent(){
      this.pixelService.trackViewContent({
        content_name: 'Cardápio Digital',
        content_ids: '',
        content_type: 'product_group',
        value: 0,
        currency: 'BRL',
        eventref: this.pixelService.getEventRef() || '',
      })
    }

  //#endregion

  }
